module.exports = __webpack_public_path__ + "static/media/logo.35e4d55e.png";